import { Dropdown } from 'react-bootstrap'
import SvgIcon from '../SVG/svg'
import ThInputCheckbox from './th-input-checkbox'

type Props = {
	id: string,
	label: string | React.ReactNode,
	labelShow?: boolean,
	optionsArrays: {
		id: string,
		name: string
	}[][]
	required?: boolean
}
const ThDropdown = ({id, label, optionsArrays, required = false, labelShow = true}: Props) => {
  return (
	<div className='th-dropdown' style={{marginBottom: '24px'}}>
		{labelShow && <label htmlFor="dropdown">
			{label}
			{required && <span className='text-primary'>*</span>}
		</label>}
		<Dropdown id="dropdown">
			<Dropdown.Toggle>Select <SvgIcon type='chevron-up'/></Dropdown.Toggle>
			<Dropdown.Menu className='dropdown-menu-checkbox'>
				{optionsArrays.map((options, index) => (
					<div key={index} className='dropdown-menu-checkbox-block'>
						{options.map(option => (
							<ThInputCheckbox label={option.name} value={false} />
						))}
						{optionsArrays.length === index + 1 ? 
							<a href='#' className="dropdown-menu-checkbox-more">
								<SvgIcon type='circle-add' fill='currentColor' width={20} height={20} />
								Add more
							</a> : ''}
					</div>
				))}
			</Dropdown.Menu>
		</Dropdown>
	</div>
  )
}
export default ThDropdown